import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { fetchCart, removeCartItem } from "slices/cartReducer";
import { useAppDispatch } from "store/appHooks";

const ListItem = ({
  data,
  isLast,
  checkoutDates,
}: {
  data: any;
  isLast: boolean;
  checkoutDates: any;
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const matchesSm = useMediaQuery(theme.breakpoints.down("sm"));
  const matchesXs = useMediaQuery(theme.breakpoints.only("xs"));
  return (
    <Box
      sx={{
        display: "flex",
        gap: { md: "20px", lg: "20px", xl: "20px", sm: "10px", xs: "10px" },
      }}
    >
      <Box
        component="img"
        src={data?.listings?.images?.[0]?.preview_url}
        alt=""
        height="88px"
        sx={{
          minWidth: {
            md: "128px",
            lg: "128px",
            xl: "128px",
            sm: "88x",
            xs: "88px",
          },
          maxWidth: {
            md: "128px",
            lg: "128px",
            xl: "128px",
            sm: "88x",
            xs: "88px",
          },
          borderRadius: "8px",
        }}
        onClick={() => navigate("/listing-detail/" + data.listing_id)}
      />
      <Box
        sx={{
          borderBottom: !isLast ? "1px solid #E2E2E2" : "",
          flex: 1,
          pb: "15px",

          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: {
                md: "20px",
                lg: "20px",
                xl: "20px",
                sm: "14px",
                xs: "14px",
              },
              fontWeight: "600",
              lineHeight: {
                md: "30px",
                lg: "30px",
                xl: "30px",
                sm: "20px",
                xs: "20px",
              },
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: matchesSm || matchesXs ? 2 : 1,
              WebkitBoxOrient: "vertical",
            }}
          >
            {data?.listings?.listing_name}
          </Typography>
          <Typography
            sx={{
              lineHeight: "31px",
              color: "#6E8C20",
              fontWeight: 600,
              fontSize: {
                md: "18px",
                lg: "18px",
                xl: "18px",
                sm: "13px",
                xs: "13px",
              },
            }}
          >
            {new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              currencyDisplay: "narrowSymbol",
            }).format(data?.listings?.price)}{" "}
            • {data?.delivery_type === 0 ? "Pickup" : "Delivery"}
          </Typography>
          <Typography
            sx={{
              color: "#A2A2A2",
              fontSize: {
                md: "16px",
                lg: "16px",
                xl: "16px",
                sm: "12px",
                xs: "12px",
              },
              fontWeight: 500,
              lineHeight: {
                md: "34px",
                lg: "34px",
                xl: "34px",
                sm: "22px",
                xs: "22px",
              },
            }}
          >
            Rental period:{" "}
            {checkoutDates.start
              ? moment(checkoutDates.start).format("MMM DD")
              : "No Date"}{" "}
            -{" "}
            {checkoutDates.end
              ? moment(checkoutDates.end).format("MMM DD")
              : "No Date"}
          </Typography>
        </Box>
        <img
          src="/assets/img/icons/trash.svg"
          alt=""
          width="24"
          height="24"
          onClick={() =>
            dispatch(
              removeCartItem({
                id: data.id,
                onSuccess: () => dispatch(fetchCart({ clearIfNoItem: true })),
              })
            )
          }
        />
      </Box>
    </Box>
  );
};

export default ListItem;
